import { IEnergyOffer, IFuelTypes, IPlanAvailability } from '../Energy';
import { ILPGOffer } from '../LPG';

import { STATE } from '../types';
import { IBroadbandOffer } from '../Broadband';

/**
 * Root namespace key for Origin sales related details
 * @type {string}
 */
export const SALES_DETAIL_KEY = 'OriginSalesDetails';

export enum YesNoE {
  Yes = 'Yes',
  No = 'No',
}

export enum CustomerTypeE {
  RESIDENTIAL = '0001',
  BUSINESS = '0002',
}

export enum ConnectionScenarioE {
  CUST_MOUT = 'CUST_MOUT',
  CUST_MOVE = 'CUST_MOVE',
  CUST_PRCH = 'CUST_PRCH',
  CUST_SWT = 'CUST_SWT',
  CUST_VC = 'CUST_VC',
  PROS_MOVE = 'PROS_MOVE',
  PROS_SWT = 'PROS_SWT',
  PROS_VC = 'PROS_VC',
  ACC_TRF = 'ACC_TRF',
}

export interface GreenSelected {
  '01': '0' | '25' | '50' | '100';
  '02': '0' | '100';
}

export type PlanFuelSelection = 'Gas' | 'Elec' | 'Elec_Gas';

export enum SalesSessionStoreKeys {
  SELECTED_PLAN = 'selectedPlan',
  SELECTED_PLAN_V2 = 'selectedPlan_V2',
  PLAN_FUEL = 'planfuel',
  ADDRESS_ID = 'addressId',
  ORIGIN_ADDRESS_ID = 'originAddressId',
  NMI = 'nmi',
  CONNECTION_SCENARIO = 'connectionScenario',
  GREEN_OPTIONS_SELECTED = 'greenOptionsSelected',
  PLAN_SOLAR = 'planSolar',
  SEARCH_POSTCODE = 'searchPostcode',
  SELECTED_LPG_OFFER = 'selectedLPGOffer',
  CUSTOMER_TYPE = 'customerType',
  DTM_STATE = 'dtmstate',
  REFERRAL_CODE = 'referralCode',
  CAMPAIGN_CODE_CONFIG = 'campaignCodeConfig',
  ATTRIBUTION = 'attribution',
  SELECTED_BROADBAND_OFFER = 'selectedBroadbandOffer',
  USER_ENERGY_SELECTION = 'userEnergySelection',
  IS_CES_ADDRESS = 'isCesAddrss',
  CES_ADDRESS_QUERY = 'cesAddresssQuery',
  INTERNET_SELECTED = 'internetSelected',
  ESPEC_SESSION_ID = 'especSessionId',
  ADDRESS_ENTRY_ESPEC = 'addressEntryEspec',
  SELECTED_PLANS_ESPEC = 'selectedPlansEspec',
  CID = 'cid',
}

interface ISalesSessionStore {
  [SalesSessionStoreKeys.SELECTED_PLAN]: IPlanAvailability;
  [SalesSessionStoreKeys.SELECTED_PLAN_V2]: IEnergyOffer;
  [SalesSessionStoreKeys.PLAN_FUEL]: PlanFuelSelection;
  [SalesSessionStoreKeys.ADDRESS_ID]: string;
  [SalesSessionStoreKeys.ORIGIN_ADDRESS_ID]: string;
  [SalesSessionStoreKeys.NMI]: string;
  [SalesSessionStoreKeys.CONNECTION_SCENARIO]: ConnectionScenarioE;
  [SalesSessionStoreKeys.GREEN_OPTIONS_SELECTED]: GreenSelected;
  [SalesSessionStoreKeys.PLAN_SOLAR]: YesNoE;
  [SalesSessionStoreKeys.SEARCH_POSTCODE]: string;
  [SalesSessionStoreKeys.SELECTED_LPG_OFFER]: ILPGOffer;
  [SalesSessionStoreKeys.CUSTOMER_TYPE]: CustomerTypeE;
  [SalesSessionStoreKeys.DTM_STATE]: string;
  [SalesSessionStoreKeys.REFERRAL_CODE]: string;
  [SalesSessionStoreKeys.CAMPAIGN_CODE_CONFIG]: CampaignCodeConfig;
  [SalesSessionStoreKeys.ATTRIBUTION]: AttributionData;
  [SalesSessionStoreKeys.SELECTED_BROADBAND_OFFER]: IBroadbandOffer;
  [SalesSessionStoreKeys.USER_ENERGY_SELECTION]: UserEnergySelection;
  [SalesSessionStoreKeys.IS_CES_ADDRESS]: YesNoE;
  [SalesSessionStoreKeys.CES_ADDRESS_QUERY]: string;
  [SalesSessionStoreKeys.INTERNET_SELECTED]: boolean;
  [SalesSessionStoreKeys.ESPEC_SESSION_ID]: string;
  [SalesSessionStoreKeys.ADDRESS_ENTRY_ESPEC]: object;
  [SalesSessionStoreKeys.SELECTED_PLANS_ESPEC]: object;
  [SalesSessionStoreKeys.CID]: string;
}

export type SalesDetailsType = Partial<ISalesSessionStore>;

type CustomerType = 'resi' | 'business';
type CampaignCodeConfigPerFuelType<K> = Partial<Record<IFuelTypes, K>>;
type CampaignCodeConfigPerState<K> = Partial<Record<STATE, K>>;
type CampaignCodeConfigPerCustomerType<K> = Partial<Record<CustomerType, K>>;

export type CampaignCodeConfig = CampaignCodeConfigPerState<
  CampaignCodeConfigPerCustomerType<CampaignCodeConfigPerFuelType<string | string[]>>
>;

export type AttributionData = {
  vppReferralPartner?: string;
  vppOffer?: string;
  referenceCode?: string;
  customerCode?: string;
  affiliateID?: string;
  partnerReferenceNumber?: string;
};

export type UserEnergySelection = {
  electricity?: boolean;
  gas?: boolean;
};
